// extracted by mini-css-extract-plugin
export var backButton = "component-module--backButton--47784";
export var cookieGroupHeader = "component-module--cookieGroupHeader--0fb5c";
export var headlineSwitchContainer = "component-module--headlineSwitchContainer--069d9";
export var switchBlock = "component-module--switchBlock--f9fcf";
export var switchCheckedInactive = "component-module--switchCheckedInactive--c386f";
export var switchMark = "component-module--switchMark--4397c";